<template>
  <el-image
    :src="realSrc"
    fit="cover"
    :style="`width:${realWidth};height:${realHeight};`"
    :preview-src-list="realSrcList"
  >
    <div slot="error" class="image-slot">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
</template>

<script>
import { isExternal } from "@/common/utils/validate";
import { PICTURE_URL } from "@/common/constant/Const";

export default {
  name: "ImagePreview",
  props: {
    src: {
      type: String,
      default: "",
    },
    width: {
      type: [Number, String],
      default: "",
    },
    height: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      baseUrl: "", // 图片前缀
      computedSrc: "", // 存储计算的图片路径
      computedSrcList: [], // 存储多个图片路径
    };
  },
  async mounted() {
    try {
      this.baseUrl = await PICTURE_URL; // 获取图片前缀
      this.updateImagePaths(); // 获取图片路径
    } catch (error) {
      console.error("获取图片 URL 失败:", error);
    }
  },
  watch: {
    src: "updateImagePaths", // 监听 src 变化，重新计算路径
    baseUrl: "updateImagePaths", // 监听 baseUrl 变化，重新计算路径
  },
  methods: {
    updateImagePaths() {
      if (!this.baseUrl || !this.src) {
        return;
      }

      // 计算单个图片的路径
      let realSrc = this.src.split(",")[0];
      this.computedSrc = isExternal(realSrc) ? realSrc : `${this.baseUrl}/${realSrc}`;

      // 计算多个图片的路径
      let realSrcList = this.src.split(",");
      this.computedSrcList = realSrcList.map(item =>
        isExternal(item) ? item : `${this.baseUrl}/${item}`
      );
    },
  },
  computed: {
    realSrc() {
      return this.computedSrc;
    },
    realSrcList() {
      return this.computedSrcList;
    },
    realWidth() {
      return typeof this.width === "string" ? this.width : `${this.width}px`;
    },
    realHeight() {
      return typeof this.height === "string" ? this.height : `${this.height}px`;
    },
  },
};
</script>

<style lang="less" scoped>
.el-image {
  border-radius: 5px;
  background-color: #ebeef5;
  box-shadow: 0 0 5px 1px #ccc;

  ::v-deep .el-image__inner {
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      transform: scale(1.2);
    }
  }

  ::v-deep .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #909399;
    font-size: 30px;
  }
}
</style>
